export default "__VITE_ASSET__vxWYsGhd__"